import { User } from '../models/user';

export class SetUsers {
    static readonly type = '[User] SetUsers';

    constructor(public payload: User[]) {}
}
